import CreditCardPlusIcon from "@redotech/redo-icons/credit-card-plus_filled.svg";
import { memo, useState } from "react";
import Info from "../../info.svg";
import { HsaCartEligibilitySummary } from "./hsa-cart-summary";
import { hsaCartWidgetText } from "./hsa-cart-widget-text";
import * as css from "./hsa-cart-widget.module.css";
import { HsaLearnMoreModal } from "./hsa-learn-more-modal";

const TITLE = "HSA/FSA Eligible";

/**
 * The HSA/FSA cart eligibility row, rendered next to the cart's Checkout
 * button. Deliberately mirrors the Checkout+ info-card row's structure and
 * type scale so stacked Redo rows look like one component.
 *
 * The info button opens the same walkthrough the PDP badge uses; the cart
 * passes the aggregate LMN flag, so the health-assessment step appears when
 * ANY eligible line requires a Letter of Medical Necessity.
 */
export const HsaCartWidget = memo(function HsaCartWidget({
  summary,
  onLearnMore,
}: {
  summary: HsaCartEligibilitySummary;
  /** Fired when the shopper opens the walkthrough; the widget itself writes nothing. */
  onLearnMore: () => void;
}) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className={css.container} data-target="hsa-cart-widget">
        <CreditCardPlusIcon aria-hidden className={css.icon} />
        <div className={css.textContainer}>
          <span className={css.title} data-target="hsa-cart-widget-title">
            {TITLE}
            <button
              aria-haspopup="dialog"
              aria-label="How paying with an HSA or FSA works"
              className={css.infoButton}
              data-target="hsa-cart-widget-info"
              onClick={() => {
                onLearnMore();
                setModalOpen(true);
              }}
              type="button"
            >
              <Info aria-hidden className={css.infoIcon} />
            </button>
          </span>
          <br />
          <span className={css.subtext} data-target="hsa-cart-widget-subtext">
            {hsaCartWidgetText(summary)}
          </span>
        </div>
      </div>
      <HsaLearnMoreModal
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        requiresLmn={summary.anyRequiresLmn}
        subscriptionSignals={{
          variantOffersSubscription: false,
          cartHasSubscription: summary.hasSubscription,
        }}
      />
    </>
  );
});
